import { Container, Typography } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { makeStyles } from "@mui/styles";
import React from "react";

import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: "relative",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1000,
        color: "#fff",
        display: "flex !important",
        alignItems: "center",
        justifyContent: "center",
        verticalAlign: "center",
    },
}));

export default function LoadingFullScreen({ open, loadingMessage= "Loading..." }) {
    const classes = useStyles();
    const handleClose = () => {};

    return (
        <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
            <Container fixed className={"loadingFullScreenContainer"}>
                {<CircularProgress size={50} color={"secondary"} />}
                <div style={{ marginTop: 35 }}>
                    <Typography>{loadingMessage}</Typography>
                </div>
            </Container>
        </Backdrop>
    );
}

LoadingFullScreen.propTypes = {
    open: PropTypes.bool.isRequired,
    loadingMessage: PropTypes.string,
};

